import { StoryWithPages } from '@tadpoles/common'
import type {
    IdentityPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'

type LibraryStoryCollection = PersistenceCollection<StoryWithPages, 'id'>

export type LibraryStoryPersistenceCollection = Pick<
    LibraryStoryCollection,
    'bulkPut' | 'findAll' | 'remove'
>

export const LibraryStoryCollectionDefinition: IdentityPersistenceCollectionDefinition<
    typeof StoryWithPages,
    'id'
> = {
    kind: 'library-story',
    scope: 'global',
    primaryKey: 'id',
    modelSchema: StoryWithPages
}

export class FamilyLibraryStoryStore {
    readonly #collection: LibraryStoryPersistenceCollection

    public constructor(collection: LibraryStoryPersistenceCollection) {
        this.#collection = collection
    }

    public async load(signal: AbortSignal): Promise<StoryWithPages[]> {
        signal.throwIfAborted()
        const stories = await this.#collection.findAll()
        signal.throwIfAborted()
        return stories
    }

    public async replaceAll(stories: StoryWithPages[], signal: AbortSignal): Promise<void> {
        signal.throwIfAborted()
        const existing = await this.#collection.findAll()
        await Promise.all(
            existing.map(async (story) => {
                await this.#collection.remove(story.id)
            })
        )
        await this.#collection.bulkPut(stories)
    }
}
